export default __webpack_public_path__ + "static/media/pnud.939bea2a.png";